import { gql } from 'urql'

export const updateWorkflowDueDateQueryMutation = gql`
  mutation updateWorkflowDueDate($milestoneId: Int!, $workflowId: String!, $newDueDate: Date!) {
    updateWorkflowDueDate(milestoneId: $milestoneId, workflowId: $workflowId, newDueDate: $newDueDate) {
      status
      failureKey
    }
  }
`
